import { getDbOrThrow, col } from "../../core/firestoreCore";
import { COLLECTIONS } from "../../core/collections";
import { getDocs, query, where, limit } from "firebase/firestore";
import { getOrFetch, invalidate as _invalidate } from "../../cache/getOrFetch";

/**
 * Verify whether an (email, pp_invitation_key) pair exists.
 * Cache briefly to avoid repeated reads on the same step.
 */
const TTL_INVITE = Number(process.env.REACT_APP_TTL_INVITATION_VERIFY_MS) || 24 * 60 * 60 * 1000;

export async function verifyBetaInvitationForEmail(emailRaw, invitationKeyRaw, opts = {}) {
  const email = String(emailRaw || "").trim().toLowerCase();
  const invitationKey = String(invitationKeyRaw || "").trim();
  if (!email || !invitationKey) return false;

  if (opts?.noCache) {
    const db = getDbOrThrow();
    const base = col(db, COLLECTIONS.systemBetaInvitations);
    const qy = query(base, where("email", "==", email), where("pp_invitation_key", "==", invitationKey), limit(1));
    const snap = await getDocs(qy);
    return !snap.empty;
  }

  const key = `invitation:${email}:${invitationKey}`;
  return getOrFetch({
    key,
    ttlMs: opts.ttlMs ?? TTL_INVITE,
    persist: true,
    persistKey: key,
    fetcher: async () => {
      const db = getDbOrThrow();
      const base = col(db, COLLECTIONS.systemBetaInvitations);
      const qy = query(base, where("email", "==", email), where("pp_invitation_key", "==", invitationKey), limit(1));
      const snap = await getDocs(qy);
      return !snap.empty;
    },
  });
}

export function invalidateInvitationVerifyCache(email, invitationKey) {
  const key = `invitation:${String(email || "").toLowerCase().trim()}:${String(invitationKey || "").trim()}`;
  _invalidate(key);
}
